import { Globe, Megaphone, BarChart3, Store, Palette, MessagesSquare, Briefcase } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { TOOL_CATEGORIES } from "../../data/site";

const ICONS = [Globe, Megaphone, BarChart3, Store, Palette, MessagesSquare, Briefcase];

export const Tools = () => (
  <section id="tools" data-testid="tools-section" className="py-24 sm:py-28 bg-white border-y border-slate-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        overline="Digital Tools"
        title="Digital Tools You'll Learn to Use"
        sub="Practical exposure to the tools commonly used for creating, marketing and operating online businesses."
      />
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {TOOL_CATEGORIES.map((c, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={c.title} delay={(i % 3) * 0.08} className={i === TOOL_CATEGORIES.length - 1 ? "lg:col-start-2" : ""}>
              <div
                data-testid={`tool-category-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full bg-background border border-slate-200/80 rounded-2xl p-6 hover:border-electric/40 hover:shadow-xl hover:shadow-electric/5 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-center gap-3.5">
                  <span className="w-11 h-11 rounded-xl bg-navy flex items-center justify-center group-hover:bg-electric transition-colors shrink-0">
                    <Icon size={18} className="text-cyanx" />
                  </span>
                  <h3 className="font-display font-semibold text-navy text-base leading-snug">{c.title}</h3>
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  {c.items.map((t) => (
                    <span key={t} className="text-xs font-medium text-slate-600 bg-white border border-slate-200 rounded-full px-3 py-1.5">{t}</span>
                  ))}
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.15}>
        <p className="mt-8 text-xs text-slate-400 max-w-2xl">
          Tools and platforms may be updated or substituted depending on current availability, pricing and business requirements. All platform names belong to their respective owners.
        </p>
      </Reveal>
    </div>
  </section>
);
